import React, { useState } from "react";
import { Layout, Menu, Typography, Button, Drawer } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import { MenuOutlined } from "@ant-design/icons";
import { NAVIGATION_ITEMS } from "../../utils/constants/navigation";

const { Header } = Layout;
const { Title } = Typography;

const Navigation: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleMenuClick = ({ key }: { key: string }) => {
    navigate(key);
    setMobileMenuOpen(false); // Close mobile menu after navigation
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <Header className="glass-nav">
      <div className="nav-container">
        {/* Logo/Brand */}
        <div className="nav-brand">
          <Title
            level={3}
            className="glass-text"
            style={{
              margin: 0,
              cursor: "pointer",
              textShadow: "0 2px 4px rgba(0, 0, 0, 0.3)",
            }}
            onClick={() => navigate("/")}
          >
            Ruhul Amin Parvez
          </Title>
        </div>

        {/* Desktop Menu */}
        <div className="nav-menu desktop-menu">
          <Menu
            mode="horizontal"
            selectedKeys={[location.pathname]}
            items={NAVIGATION_ITEMS}
            onClick={handleMenuClick}
            className="glass-menu"
          />
        </div>

        {/* Mobile Menu Button */}
        <div className="nav-menu mobile-menu">
          <Button
            type="text"
            icon={<MenuOutlined />}
            onClick={toggleMobileMenu}
            className="mobile-menu-btn"
            style={{
              color: "white",
              fontSize: "18px",
              border: "none",
              background: "transparent",
            }}
          />
        </div>

        {/* Mobile Drawer */}
        <Drawer
          title="Menu"
          placement="right"
          onClose={() => setMobileMenuOpen(false)}
          open={mobileMenuOpen}
          className="mobile-drawer"
          maskClosable={true}
          closable={true}
          destroyOnClose={true}
          styles={{
            body: {
              padding: 0,
              background: "rgba(30, 30, 60, 0.95)",
            },
            header: {
              background: "rgba(30, 30, 60, 0.98)",
              borderBottom: "1px solid rgba(255, 255, 255, 0.2)",
              color: "white",
              fontWeight: "600",
            },
            mask: {
              background: "rgba(0, 0, 0, 0.5)",
            },
            content: {
              background: "transparent",
            },
          }}
        >
          <div className="mobile-menu-container">
            <Menu
              mode="vertical"
              selectedKeys={[location.pathname]}
              items={NAVIGATION_ITEMS}
              onClick={handleMenuClick}
              className="mobile-menu-items"
              style={{
                background: "transparent",
                border: "none",
              }}
            />
          </div>
        </Drawer>
      </div>
    </Header>
  );
};

export default Navigation;
